


























































































































































































































































































































































































































import { Component, PropSync, Vue, Watch } from "vue-property-decorator";
import { ReservationAccUnitModel, ReservationModel } from "./types";
import {
  calculateAddOnServiceQuantity,
  addOnServiceNeedsRange,
} from "./functions";
import { Action, Getter } from "vuex-class";
import { Currency } from "@/shared/models/currency";
import { TaxRateView } from "@/shared/models/taxRates";
import {
  CalculationMethods,
  PriceCalculationMethodView,
} from "@/shared/models/priceCalculationMethods";
import { AddOnServiceModel } from "./types";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import NumericInput from "@/components/misc/NumericInput.vue";
import { DateTime } from "luxon";
import { policyChecker } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";
import RequireRole from "@/components/misc/RequireRole.vue";
import { PriceCalculationMethodsEnum } from "@/shared/models/enums.type";
import { FinancialSettingsType } from "@/store/modules/financial";
import {
  CurrencyConversionService,
  currencyConversionServiceFactory,
} from "@/shared/currencyConversionService";
import * as _ from "lodash";
import { UnitOfMeasureView } from "@/shared/models/unitOfMeasure";
import DateField from "@/components/misc/DateField.vue";
import { differenceInYears, getAge } from "@/shared/dateFormatUtils";
import { round } from "@/components/numbers/numberFormatUtils";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";

export type BookingFeesFactors = {
  accommodationPrice: number;
  servicesPrice: number;
};

@Component({
  components: {
    RightDrawer,
    NumericInputImproved,
    CurrencyDisplay,
    RequireRole,
    NumericInput,
    DateField,
  },
})
export default class ReservationFormUnitAddOnServices extends Vue {
  @PropSync("reservation", { default: undefined })
  reservationModel?: ReservationModel;
  @PropSync("unit", { default: undefined }) model?: ReservationAccUnitModel;
  @PropSync("formOpen", { default: false }) anyFormOpen?: boolean;

  @Action("codebooks/refreshCurrencies")
  refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];
  @Action("codebooks/refreshPriceCalculationMethods")
  refreshPriceCalculationMethods?: () => Promise<void>;
  @Getter("codebooks/priceCalculationMethods")
  priceCalculationMethods?: PriceCalculationMethodView[];
  @Action("codebooks/refreshTaxRates")
  refreshTaxRates?: () => Promise<void>;
  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];
  @Getter("codebooks/unitsOfMeasure") unitsOfMeasure?: UnitOfMeasureView[];
  @Action("appParams/refreshAppParams") refreshAppParams?: () => Promise<void>;
  @Getter("appParams/tenantPaysVat") tenantPaysVat?: boolean;
  @Getter("appParams/calculateWithEVisitorDates")
  calculateWithEVisitorDates?: boolean;
  @Getter("appParams/showAOSPeriodColumn") showAOSPeriodColumn?: boolean;
  @Getter("appParams/tenantShowAddOnServiceDiscount")
  showAddOnServiceDiscount?: boolean;

  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;
  @Getter("financial/settings") financialSettings?: FinancialSettingsType;

  @Getter("auth/claims") claims?: JwtClaims;

  get canEditAddons() {
    return policyChecker("MODIFY_RESERVATION_ADDONS")(this.claims);
  }

  get unitCurrencyId() {
    return (
      this.model?.ratePlan?.currencyId ??
      this.financialSettings?.workingCurrency.id
    );
  }

  nameFilter = "";
  itemsPerPage = 10;
  page = 1;
  get filteredItems() {
    const filtered = this.addItemsArray.filter((item) =>
      item.name.toLowerCase().includes(this.nameFilter.toLowerCase())
    );
    return filtered;
  }

  get pagingText() {
    const max = this.filteredItems.length;
    const lower = (this.page - 1) * this.itemsPerPage + 1;
    const higher = Math.min(this.page * this.itemsPerPage, max);
    const item = `${lower}-${higher}`;
    return this.$t("{item} of {items}", { item: item, items: max });
  }

  @Watch("nameFilter")
  nameFilterWatch() {
    this.page = 1;
  }

  currencyConversionService?: CurrencyConversionService;
  async created() {
    const promises = [];

    if (!this.financialSettings && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }

    if (this.tenantPaysVat === undefined && this.refreshAppParams) {
      promises.push(this.refreshAppParams());
    }
    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      promises.push(this.refreshCurrencies());
    }
    if (
      (this.priceCalculationMethods?.length ?? 0) === 0 &&
      this.refreshPriceCalculationMethods
    ) {
      promises.push(this.refreshPriceCalculationMethods());
    }
    if ((this.taxRates?.length ?? 0) === 0 && this.refreshTaxRates) {
      promises.push(this.refreshTaxRates());
    }
    await Promise.all(promises);

    if (this.financialSettings) {
      this.currencyConversionService = currencyConversionServiceFactory(
        this.financialSettings
      );
    }

    if (this.model?.selectedServices.filter((x) => x.isCityTax).length == 0) {
      this.reAddCityTax = false;
    }
    if (!this.tenantPaysVat) {
      this.headers = this.headers.filter((x) => x.value !== "taxRateId");
    }
  }

  availableServicesCopy: AddOnServiceModel[] = [];

  addFormOpen = false;

  @Watch("addFormOpen")
  addFormOpenChanged(fresh: boolean) {
    this.page = 1;
    if (fresh && this.model?.availableServices) {
      this.anyFormOpen = true;
      this.availableServicesCopy = _.cloneDeep(this.model?.availableServices);
      this.availableServicesCopy =
        this.availableServicesCopy.filter(
          (x) =>
            !this.items.some(
              (s) => s.isCityTax && s.addOnServiceId == x.addOnServiceId
            )
        ) || [];
      this.availableServicesCopy.forEach((element) => {
        element.decimalQuantity = this.getDefaultQuantity(element);
        this.setGrossPrice(element, true);
      });
    }
    if (fresh == false) {
      this.anyFormOpen = false;
    }
  }

    accUnitNetPrice(){
    if (this.model && this.model?.dayPrices && this.model.dayPrices.length > 0) { 

      let dayPricesTotal = 0;
      dayPricesTotal = round(this.model.dayPrices.reduce((sum, e) => sum + e.price, 0), 2);
    
      if (this.model.discountPercent) {
        dayPricesTotal = round (dayPricesTotal * (1 - this.model.discountPercent / 100), 2);
      }

      const accUnitTaxRate = this.financialSettings?.accomodationUnitTypesTaxRate.rate ?? 0;  
      const accUnitNetPriceTotal = round((dayPricesTotal / (1 + (accUnitTaxRate / 100))), 2);

      return accUnitNetPriceTotal;
    }
  }

  needsRange(item: AddOnServiceModel) {
    return addOnServiceNeedsRange(item.calculationMethodId);
  }

  @Watch("items")
  itemsChanged(fresh: AddOnServiceModel[]) {
    if (fresh.filter((x) => x.isCityTax).length == 0) {
      this.reAddCityTax = false;
    } else {
      this.reAddCityTax = true;
    }
  }

  get hasAvailableService() {
    if (this.model && this.model.availableServices) {
      return this.model.availableServices.length > 0;
    }
    return false;
  }

  get items() {
    if (
      this.model &&
      this.addOnServiceQuantityFactors.numberOfTaxableChildren > 0
    ) {
      const childCityTaxService = this.model.availableServices?.find(
        (x) =>
          x.calculationMethodId ==
            PriceCalculationMethodsEnum.PerChildPerNight && x.isCityTax
      );

      if (childCityTaxService) {
        const alreadyExists = this.model.selectedServices.some(
          (x) =>
            x.addOnServiceId === childCityTaxService.addOnServiceId &&
            x.calculationMethodId ==
              PriceCalculationMethodsEnum.PerChildPerNight
        );

        if (!alreadyExists) {
          const childServiceToAdd = _.cloneDeep(childCityTaxService);
          childServiceToAdd.decimalQuantity =
            this.addOnServiceQuantityFactors.numberOfTaxableChildren *
            this.addOnServiceQuantityFactors.numberOfDays;

          this.model?.selectedServices.push(childServiceToAdd);
        }
      }
    }

    return this.model?.selectedServices || [];
  }
  get itemsForTable() {
    return this.items.map((item, index) => {
      const needsRange = this.needsRange(item);

      item.idx = index;

      if (needsRange) {
        if (!item.serviceDateFrom) {
          item.serviceDateFrom = this.model?.arrivalDate.substr(0, 10) ?? "";
        } else {
          item.serviceDateFrom = item.serviceDateFrom.substr(0, 10);
        }

        if (!item.serviceDateTo) {
          item.serviceDateTo = this.model?.departureDate.substr(0, 10) ?? "";
        } else {
          item.serviceDateTo = item.serviceDateTo.substr(0, 10);
        }

        item.serviceRange = [item.serviceDateFrom, item.serviceDateTo];
      } else {
        if (!item.serviceDateFrom) {
          item.serviceDateFrom = this.model?.arrivalDate.substr(0, 10) ?? "";
        } else {
          item.serviceDateFrom = item.serviceDateFrom.substr(0, 10);
        }
      }

      return {
        ...item,
        index: index,
      };
    });
  }

  addItemsArray: AddOnServiceModel[] = [];
  get factorsForAddServicesListRefresh() {
    return {
      services: this.availableServicesCopy,
      unitCurrencyId: this.unitCurrencyId,
    };
  }
  @Watch("factorsForAddServicesListRefresh", { deep: true, immediate: true })
  factorsForAddServicesListRefreshWatch() {
    const services = _.cloneDeep(this.availableServicesCopy);

    // in case a rate plan that is not in the working currency is selected for the unit, convert add on services to the rate plan's currency
    // in case of rate plans with working currency, keep the services as they are
    if (this.unitCurrencyId != this.financialSettings?.workingCurrency.id) {
      services
        .filter((s) => !s.isCityTax)
        .forEach((s) =>
          this.convertServiceCurrency(s, this.unitCurrencyId ?? s.currencyId)
        );
    }

    this.addItemsArray = services;
  }

  // when unit's currency is changed (by changing the rate plan for example) convert the services as usual
  // unless the new currency === working currency, in this case reset services currencies to original
  @Watch("unitCurrencyId")
  unitCurrencyIdWatch() {
    if (this.unitCurrencyId && this.currencyConversionService) {
      this.items
        .filter((x) => !x.isCityTax)
        .forEach((x) => {
          if (
            this.unitCurrencyId === this.financialSettings?.workingCurrency.id
          ) {
            this.resetServiceCurrency(x);
          } else {
            this.convertServiceCurrency(x, this.unitCurrencyId ?? x.currencyId);
          }
        });
    }
  }

  convertServiceCurrency(service: AddOnServiceModel, currencyId: number) {
    service.netUnitPrice =
      this.currencyConversionService?.convertCurrency(
        service.netUnitPrice,
        service.currencyId,
        currencyId
      ) ?? service.netUnitPrice;

    service.grossPrice =
      this.currencyConversionService?.convertCurrency(
        service.grossPrice,
        service.currencyId,
        currencyId
      ) ?? service.grossPrice;

    if (service.periods) {
      service.periods.forEach((p) => {
        p.amount =
          this.currencyConversionService?.convertCurrency(
            p.amount,
            service.currencyId,
            currencyId
          ) ?? p.amount;
      });
    }

    service.currencyId = currencyId;
  }
  isFormValid = false;

  resetServiceCurrency(service: AddOnServiceModel) {
    const originalServiceCurrency = this.model?.availableServices.find(
      (x) => x.addOnServiceId == service.addOnServiceId
    )?.currencyId;

    if (originalServiceCurrency) {
      this.convertServiceCurrency(service, originalServiceCurrency);
    }
  }

  headers = [] as {
    text: string;
    value: string;
    class?: string;
    sortable?: boolean;
    align?: string;
  }[];

  @Watch("showAddOnServiceDiscount", { immediate: true })
  showAddOnServiceDiscountWatch() {
    this.headers = [
      { text: "Reservation.AddOnService.Name", value: "name" },
      { text: "Date", value: "serviceDateFrom", class: "date-header" },
      { text: "AddOnService.CalculationMethod", value: "calculationMethodId" },
      { text: "AddOnService.UnitOfMeasure", value: "unitOfMeasureId" },
      { text: "Reservation.AddOnService.Quantity", value: "decimalQuantity" },
      {
        text: "VFinancialDocument.LineItem.grossUnitPrice",
        value: "grossUnitPrice",
      },
      { text: "Reservation.AddOnService.TaxRate", value: "taxRateId" },
      ...(this.showAddOnServiceDiscount
        ? [
            {
              text: "Reservation.AddOnService.Discount",
              value: "discountPercent",
            },
          ]
        : []),
      { text: "Reservation.AddOnService.GrossPrice", value: "grossPrice" },
      { text: "", value: "actions", sortable: false, align: "end" },
    ];
  }

  get allowedHeaders() {
    let headers = this.headers;

    if (!this.showAOSPeriodColumn) {
      headers = headers.filter((x) => x.value !== "serviceDateFrom");
    }

    return this.canEditAddons
      ? headers
      : headers.filter((x) => x.value !== "actions");
  }

  get translatedHeaders() {
    return this.allowedHeaders.map((x) => ({ ...x, text: this.$t(x.text) }));
  }

  getServiceName(service: AddOnServiceModel) {
    let toReturn = service.name;
    if (
      service.to &&
      service.from &&
      this.itemsForTable.filter(
        (x) => x.addOnServiceId == service.addOnServiceId
      ).length > 1
    ) {
      toReturn += ` (${this.$d(new Date(service.from))} - ${this.$d(
        new Date(service.to)
      )})`;
    }

    return toReturn;
  }

  getUnitOfMeasure(item: AddOnServiceModel) {
    const uom = this.unitsOfMeasure?.find((x) => x.id == item.unitOfMeasureId);
    return uom?.textResourceKey;
  }

  priceCalculationMethodDisplay(priceCalculationMethodId: number) {
    const pcm = this.priceCalculationMethods?.find(
      (tr) => tr.id === priceCalculationMethodId
    );
    return pcm ? this.$t(pcm.textResourceKey) : "";
  }

  taxRateDisplay(taxRateId: number) {
    const taxRate = this.taxRates?.find((t) => t.id === taxRateId);
    return taxRate ? this.$t(taxRate.textResourceKey) : "";
  }

  setDiscount(item: AddOnServiceModel) {
    const totalGrossPrice = round(
      item.grossUnitPrice * item.decimalQuantity,
      2
    );
    const priceFactor =
      totalGrossPrice != 0 ? round(item.grossPrice / totalGrossPrice, 8) : 1;
    const discountFactor = (1 - priceFactor) * 100;
    item.discountPercent = round(discountFactor, 6);
    //item.grossPrice = this.setGrossPrice(item);
  }

  setGrossPrice(item: AddOnServiceModel, isForDrawer = false) {
    const taxRateFactor = round(
      (this.taxRates?.find((e) => e.id === item.taxRateId)?.rate ?? 0) / 100,
      4
    );
    const discountFactor = item.discountPercent
      ? 1 - round(item.discountPercent / 100, 8)
      : 1;

    if (item.isRelative) {
       const matchingAvailableService = this.model?.availableServices.find( (x) => x.addOnServiceId === item.addOnServiceId) ||
          this.model?.selectedServices.find((x) => x.addOnServiceId === item.addOnServiceId)                                      
        if (matchingAvailableService) {
          item.grossUnitPrice = round((matchingAvailableService.grossUnitPrice / 100) * (this.accUnitNetPrice() ?? 0));
      }
    }
    
    const totalGrossPrice = round(item.grossUnitPrice * item.decimalQuantity, 2);
    let grossPrice = round(totalGrossPrice * discountFactor, 2);

    if (item.pricesAreSeasonal) {
      if ((isForDrawer && item.id > 0) || (!item.from && !item.to)) {
        const today = new Date().toISOString().substring(0, 10);
        const period = item.periods.find(
          (x) =>
            today >= x.from.substring(0, 10) && today <= x.to.substring(0, 10)
        );
        item.grossUnitPrice = period ? period.amount : item.grossUnitPrice;
        grossPrice = period
          ? round(round(period.amount * item.decimalQuantity) * discountFactor)
          : grossPrice;
      } else {
        const period = item.periods.find(
          (x) =>
            x.from.substring(0, 10) == item.from &&
            x.to.substring(0, 10) == item.to
        );
        grossPrice = period
          ? round(round(period.amount * item.decimalQuantity) * discountFactor)
          : grossPrice;
        item.grossUnitPrice = period ? period.amount : item.grossUnitPrice;
      }
    }
    item.grossPrice = round(grossPrice);
    item.netUnitPrice = round(item.grossUnitPrice / (1 + taxRateFactor));
    return item.grossPrice;
  }

  getDefaultQuantity(item: AddOnServiceModel) {
    const stayLength = this.differenceInDays(
      new Date(this.model?.arrivalDate ?? ""),
      new Date(this.model?.departureDate ?? "")
    );
    const numAdults = this.model?.numberOfAdults ?? 0;
    const numChildren = this.model?.numberOfChildren ?? 0;
    const numTaxableChildren =
      this.model?.childrenAges.filter((x) => x > 11 && x < 18).length ?? 0;
    const numPersons = numAdults + numChildren;

    //sensible defaults for quantities
    switch (item.calculationMethodId) {
      case CalculationMethods.PerStay:
        return 1;
      case CalculationMethods.PerNight:
        return stayLength;
      case CalculationMethods.PerPersonPerNight:
        return numPersons * stayLength;
      case CalculationMethods.PerPerson:
        return numPersons;
      case CalculationMethods.PerAdultPerson:
        return numAdults;
      case CalculationMethods.PerAdultPerNight:
        return numAdults * stayLength;
      case CalculationMethods.PerChildPerNight:
        return item.isCityTax
          ? numTaxableChildren * stayLength
          : numChildren * stayLength;
      case CalculationMethods.Manual:
        return 0;
      case CalculationMethods.PerDay:
        return stayLength + 1;
      default:
        return 0;
    }
  }

  serviceQuantityEdited: number[] = [];
  selectedToAdd: AddOnServiceModel[] = [];
  add(selected: AddOnServiceModel[]) {
    if (this.model && this.reservationModel) {
      let toAdd: AddOnServiceModel[] = [];
      for (const service of selected) {
        //calculation for seasonal AOS is done separately
        toAdd.push(service);
        if (
          service.periods &&
          service.periods.length != 0 &&
          !service.isEditedManually
        ) {
          toAdd = toAdd.concat(
            service.periods.map((x) => {
              return {
                ...service,
                grossUnitPrice: x.amount,
                grossPrice: this.setGrossPrice(service),
                from: x.from.substring(0, 10),
                to: x.to.substring(0, 10),
                serviceDateFrom: x.from.substring(0, 10),
                serviceDateTo: x.to.substring(0, 10),
                periods: service.periods,
              } as AddOnServiceModel;
            })
          );
        }
      }

      for (const service of toAdd) {
        if (!this.serviceQuantityEdited.includes(service.addOnServiceId)) {
          calculateAddOnServiceQuantity(
            service,
            this.model,
            this.calculateWithEVisitorDates ?? false
          );
        }
        this.setGrossPrice(service);
      }

      toAdd = this.removeZeroQuantityCityTax(toAdd);

      this.adjustPeriodizedItems(
        toAdd.filter(
          (x) =>
            x.isCityTax &&
            x.calculationMethodId == CalculationMethods.PerAdultPerNight
        )
      );
      this.adjustPeriodizedItems(
        toAdd.filter(
          (x) =>
            x.isCityTax &&
            x.calculationMethodId == CalculationMethods.PerChildPerNight
        )
      );

      this.model.selectedServices.push(...toAdd);
      this.$emit("servicesListChanged");
      this.addFormOpen = false;
      this.serviceQuantityEdited = [];
      this.selectedToAdd = [];
    }
  }

  addItem(item: AddOnServiceModel, reAddSeasonPrices: boolean) {
    if (this.model && this.reservationModel) {
      if (item.isCityTax) {
        this.availableServicesCopy = this.availableServicesCopy.filter(
          (x) => x.id !== item.id
        );
      }

      const itemToAdd = _.cloneDeep(item);
      itemToAdd.id = 0;

      if (itemToAdd.decimalQuantity != this.getDefaultQuantity(itemToAdd)) {
        //flag item as edited manually only if user changed the quantity manually when selecting
        //to avoid recalculating quantity automatically in such cases
        itemToAdd.isEditedManually = true;
      }

      if (this.needsRange(itemToAdd)) {
        itemToAdd.serviceDateFrom = this.model?.arrivalDate ?? "";
        itemToAdd.serviceDateTo = this.model?.departureDate ?? "";
        itemToAdd.serviceRange = [
          itemToAdd.serviceDateFrom,
          itemToAdd.serviceDateTo,
        ];
      } else {
        let defaultDate = new Date().toISOString().substr(0, 10);

        if (
          new Date() < new Date(this.model?.arrivalDate) ||
          new Date() > new Date(this.model?.departureDate)
        ) {
          defaultDate = this.model?.arrivalDate ?? "";
        }

        itemToAdd.serviceDateFrom = defaultDate;
        itemToAdd.serviceDateTo = null;
      }

      //remove selected seasonal prices
      //reset 'first' date so the behaviour is the same as adding seasonal AOS for the first time
      if (reAddSeasonPrices) {
        this.model.selectedServices = this.model.selectedServices.filter(
          (x) => x.addOnServiceId !== item.addOnServiceId
        );
        itemToAdd.from = "";
        itemToAdd.to = "";
      }

      let itemsToAdd: AddOnServiceModel[] = [];

      if (itemToAdd.isCityTax || itemToAdd.pricesAreSeasonal) {
        itemToAdd.isEditedManually = false;

        switch (itemToAdd.calculationMethodId) {
          case PriceCalculationMethodsEnum.PerAdultPerNight:
            itemsToAdd = this.periodizeService(itemToAdd);
            break;
          case PriceCalculationMethodsEnum.PerChildPerNight:
            itemsToAdd = this.periodizeService(itemToAdd);
            break;
          case PriceCalculationMethodsEnum.PerNight:
            itemsToAdd = this.periodizeService(itemToAdd);
            break;
          case PriceCalculationMethodsEnum.PerPersonPerNight:
            itemsToAdd = this.periodizeService(itemToAdd);
            break;
          case PriceCalculationMethodsEnum.PerDay:
            itemsToAdd = this.periodizeService(itemToAdd);
            break;
        }
      }

      if (itemsToAdd && itemsToAdd.length > 0) {
        this.model.selectedServices.push(...itemsToAdd);
      } else {
        this.model.selectedServices.push(itemToAdd);
      }

      if (
        item.isBookingFee &&
        this.model.selectedServices.some((x) => x.isBookingFee)
      ) {
        this.bookingFeeManuallyRemoved = false;
      }

      this.$emit("servicesListChanged");
    }
  }

  periodizeService(service: AddOnServiceModel) {
    let toAdd: AddOnServiceModel[] = [];

    if (this.model) {
      toAdd.push(service);
      if (service.periods && service.periods.length > 0) {
        toAdd = toAdd.concat(
          service.periods.map((x) => {
            return {
              ...service,
              netUnitPrice: x.amount,
              from: x.from.substring(0, 10),
              to: x.to.substring(0, 10),
              serviceDateFrom: x.from.substring(0, 10),
              serviceDateTo: x.to.substring(0, 10),
              periods: service.periods,
            } as AddOnServiceModel;
          })
        );
      }

      for (const service of toAdd) {
        calculateAddOnServiceQuantity(
          service,
          this.model,
          this.calculateWithEVisitorDates ?? false
        );
        this.setGrossPrice(service);
      }

      toAdd = toAdd.filter((x) => x.decimalQuantity > 0);

      this.adjustPeriodizedItems(toAdd);
    }

    return toAdd;
  }

  adjustPeriodizedItems(items: AddOnServiceModel[]) {
    if (this.model) {
      if (items.length > 0) {
        const nonPeriodizedItem = items.find((x) => !x.from && !x.to);

        if (!nonPeriodizedItem) {
          const dates = this.determineDate(items[0]);
          items[0].serviceDateFrom = dates?.minDate ?? this.model.arrivalDate;
          this.setItemRange(items[0]);

          items[items.length - 1].serviceDateTo =
            dates?.maxDate ?? this.model.departureDate;
          this.setItemRange(items[items.length - 1]);
        } else {
          const periodizedItem = items.find((x) => x != nonPeriodizedItem);

          if (periodizedItem) {
            const periodizedStartInUnitStayDate =
              this.model.arrivalDate <= periodizedItem.from &&
              periodizedItem.from <= this.model.departureDate;
            const periodizedEndInUnitStayDate =
              this.model.arrivalDate <= periodizedItem.to &&
              periodizedItem.to <= this.model.departureDate;

            if (periodizedStartInUnitStayDate) {
              const dates = this.determineDate(nonPeriodizedItem);
              //periodized item is after the default
              periodizedItem.serviceDateTo =
                dates?.maxDate ?? this.model.departureDate;
              this.setItemRange(periodizedItem);

              nonPeriodizedItem.serviceDateFrom =
                dates?.minDate ?? this.model.arrivalDate;
              if (
                periodizedItem.pricesAreSeasonal &&
                periodizedItem.calculationMethodId == CalculationMethods.PerDay
              ) {
                nonPeriodizedItem.serviceDateTo = DateTime.fromISO(
                  periodizedItem.serviceDateFrom ?? ""
                )
                  .plus({ days: -1 })
                  .toISO()
                  .substr(0, 10);
              } else {
                nonPeriodizedItem.serviceDateTo = DateTime.fromISO(
                  periodizedItem.serviceDateFrom ?? ""
                )
                  .toISO()
                  .substring(0, 10);
              }
              this.setItemRange(nonPeriodizedItem);
            }

            if (periodizedEndInUnitStayDate) {
              const dates = this.determineDate(periodizedItem);
              //periodized item is before the default
              periodizedItem.serviceDateFrom =
                dates?.minDate ?? this.model.arrivalDate;
              this.setItemRange(periodizedItem);

              if (
                periodizedItem.pricesAreSeasonal &&
                periodizedItem.calculationMethodId == CalculationMethods.PerDay
              ) {
                nonPeriodizedItem.serviceDateFrom = DateTime.fromISO(
                  periodizedItem.serviceDateTo ?? ""
                )
                  .plus({ days: 1 })
                  .toISO()
                  .substr(0, 10);
              } else {
                nonPeriodizedItem.serviceDateFrom = DateTime.fromISO(
                  periodizedItem.serviceDateTo ?? ""
                )
                  .toISO()
                  .substr(0, 10);
              }
              nonPeriodizedItem.serviceDateTo =
                dates?.maxDate ?? this.model.departureDate;
              this.setItemRange(nonPeriodizedItem);
            }
          } else {
            const dates = this.determineDate(items[0]);
            items[0].serviceDateFrom = dates?.minDate ?? this.model.arrivalDate;
            this.setItemRange(items[0]);

            items[items.length - 1].serviceDateTo =
              dates?.maxDate ?? this.model.departureDate;
            this.setItemRange(items[items.length - 1]);
          }
        }
      }
    }
  }

  determineDate(item: AddOnServiceModel) {
    if (this.calculateWithEVisitorDates && item.isCityTax) {
      if (
        this.nonLocalAdultGuestCheckInDates.length > 0 ||
        this.nonLocalChildrenGuestCheckInDates.length > 0 ||
        this.nonLocalAdultGuestCheckOutDates.length > 0 ||
        this.nonLocalChildrenGuestCheckOutDates.length > 0
      ) {
        let minDate = null;
        let maxDate = null;

        if (item.calculationMethodId == CalculationMethods.PerAdultPerNight) {
          const adultCheckInDates = this
            .nonLocalAdultGuestCheckInDates as Date[];

          if (adultCheckInDates.length > 0) {
            minDate = adultCheckInDates.reduce((x, y) => (x < y ? x : y));
            maxDate = adultCheckInDates.reduce((x, y) => (x > y ? x : y));
          }
        }

        if (item.calculationMethodId == CalculationMethods.PerChildPerNight) {
          const childrenCheckInDates = this
            .nonLocalChildrenGuestCheckInDates as Date[];

          if (childrenCheckInDates.length > 0) {
            minDate = childrenCheckInDates.reduce((x, y) => (x < y ? x : y));
            maxDate = childrenCheckInDates.reduce((x, y) => (x > y ? x : y));
          }
        }

        if (minDate) {
          //account for timezone offset since the date is in browser local timezone
          minDate.setHours(
            minDate.getHours() - minDate.getTimezoneOffset() / 60
          );
        }

        if (maxDate) {
          //account for timezone offset since the date is in browser local timezone
          maxDate.setHours(
            maxDate.getHours() - maxDate.getTimezoneOffset() / 60
          );
        }

        return {
          minDate: minDate
            ? minDate.toISOString().substr(0, 10)
            : this.model?.arrivalDate ?? "",
          maxDate: maxDate
            ? maxDate.toISOString().substr(0, 10)
            : this.model?.departureDate ?? "",
        };
      } else {
        return {
          minDate: this.model?.arrivalDate ?? "",
          maxDate: this.model?.departureDate ?? "",
        };
      }
    }
  }

  get nonLocalAdultGuestCheckInDates() {
    if (this.model) {
      return this.model.guests
        .filter(
          (x) =>
            x.city !== this.model?.city &&
            (!x.dateOfBirth || getAge(x.dateOfBirth) >= 18) &&
            x.isEVisitorCheckedIn
        )
        .map(
          (x) =>
            new Date(x.eVisitorCheckInDate ?? this.model?.arrivalDate ?? "") ??
            new Date(this.model?.arrivalDate ?? "")
        );
    }

    return [];
  }

  get nonLocalChildrenGuestCheckInDates() {
    if (this.model) {
      return this.model.guests
        .filter(
          (x) =>
            x.city !== this.model?.city &&
            x.dateOfBirth &&
            getAge(x.dateOfBirth) < 18 &&
            getAge(x.dateOfBirth) >= 12 &&
            x.isEVisitorCheckedIn
        )
        .map(
          (x) =>
            new Date(x.eVisitorCheckInDate ?? this.model?.arrivalDate ?? "") ??
            new Date(this.model?.arrivalDate ?? "")
        );
    }

    return [];
  }

  get nonLocalAdultGuestCheckOutDates() {
    if (this.model) {
      return this.model.guests
        .filter(
          (x) =>
            x.city !== this.model?.city &&
            (!x.dateOfBirth || getAge(x.dateOfBirth) >= 18) &&
            x.isEVisitorCheckedIn
        )
        .map(
          (x) =>
            new Date(
              (x.isEVisitorCheckedOut
                ? x.eVisitorCheckOutDate
                : x.checkOutDate) ??
                this.model?.departureDate ??
                ""
            ) ?? new Date(this.model?.departureDate ?? "")
        );
    }

    return [];
  }

  get nonLocalChildrenGuestCheckOutDates() {
    if (this.model) {
      return this.model.guests
        .filter(
          (x) =>
            x.city !== this.model?.city &&
            x.dateOfBirth &&
            getAge(x.dateOfBirth) < 18 &&
            getAge(x.dateOfBirth) >= 12 &&
            x.isEVisitorCheckedIn
        )
        .map(
          (x) =>
            new Date(
              (x.isEVisitorCheckedOut
                ? x.eVisitorCheckOutDate
                : x.checkOutDate) ??
                this.model?.departureDate ??
                ""
            ) ?? new Date(this.model?.departureDate ?? "")
        );
    }

    return [];
  }
  adjustSeasonalPeriodizedItems(items: AddOnServiceModel[]) {
    for (const item of items) {
      if (item.serviceRange[0] && item.serviceRange[1]) {
        if (
          item.serviceRange[0] > item.from &&
          item.serviceRange[1] < item.to
        ) {
          return;
        }
      }
    }
    return items;
  }

  setItemRange(item: AddOnServiceModel) {
    item.serviceRange = [item.serviceDateFrom, item.serviceDateTo];
  }

  removeZeroQuantityCityTax(toAdd: AddOnServiceModel[]) {
    const temp = _.clone(toAdd.filter((x) => x.isCityTax));
    for (const service of temp) {
      if (service.to && service.from && service.decimalQuantity === 0) {
        toAdd = toAdd.filter((x) => !_.isEqual(service, x));
      } else if (
        !service.to &&
        !service.from &&
        service.decimalQuantity === 0 &&
        toAdd.some(
          (x) =>
            x.addOnServiceId === service.addOnServiceId &&
            x.decimalQuantity != 0
        )
      ) {
        toAdd = toAdd.filter((x) => !_.isEqual(service, x));
      }
    }

    return toAdd;
  }

  itemRangeChanged(item: AddOnServiceModel) {
    if (this.needsRange(item)) {
      if (!Array.isArray(item.serviceRange)) {
        //when datepicker is cleared it turns the model from an array of values into an empty string
        item.serviceRange = [];
        item.serviceDateFrom = null;
        item.serviceDateTo = null;
      } else {
        item.serviceDateFrom =
          item.serviceRange.length > 0
            ? item.serviceRange[0]
            : new Date().toISOString().substr(0, 10);

        item.serviceDateTo =
          item.serviceRange.length > 1
            ? item.serviceRange[1]
            : item.serviceRange.length > 0
            ? item.serviceRange[0]
            : new Date().toISOString().substr(0, 10);
      }
    }

    if (item.serviceRange.length == 2) {
      if (this.model) {
        if (!item.pricesAreSeasonal) {
          calculateAddOnServiceQuantity(
            item,
            this.model,
            this.calculateWithEVisitorDates ?? false
          );
        } else {
          //for seasonal prices when user changes range manually on grid
          this.seasonalPricesQuantityForAOSRange(item);
        }
      }

      this.editModel = item;
      this.applyEdit(true);
      this.editModel = null;
    }
  }

  seasonalPricesQuantityForAOSRange(item: AddOnServiceModel) {
    if (this.model) {
      let numberOfNights = 0;
      if (item.serviceDateFrom && item.serviceDateTo) {
        numberOfNights = this.differenceInDays(
          new Date(item.serviceDateFrom),
          new Date(item.serviceDateTo)
        );
      }
      switch (item.calculationMethodId) {
        case CalculationMethods.PerStay: {
          item.decimalQuantity = 1;
          break;
        }
        case CalculationMethods.PerNight: {
          item.decimalQuantity = numberOfNights;
          break;
        }
        case CalculationMethods.PerPersonPerNight: {
          item.decimalQuantity =
            numberOfNights *
            (this.model.numberOfAdults + this.model.numberOfChildren);
          break;
        }
        case CalculationMethods.PerPerson: {
          item.decimalQuantity =
            this.model.numberOfAdults + this.model.numberOfChildren;
          break;
        }
        case CalculationMethods.PerAdultPerson: {
          item.decimalQuantity = this.model.numberOfAdults;
          break;
        }
        case CalculationMethods.PerChildPerNight: {
          item.decimalQuantity = numberOfNights * this.model.numberOfChildren;
          break;
        }
        case CalculationMethods.PerAdultPerNight: {
          item.decimalQuantity = numberOfNights * this.model.numberOfAdults;
          break;
        }

        case CalculationMethods.PerDay: {
          item.decimalQuantity = numberOfNights + 1;
          break;
        }
      }
    }
  }

  remove(item: AddOnServiceModel) {
    if (this.model) {
      const index = this.items.findIndex(
        (x) =>
          x.id === item.id &&
          x.idx === item.idx &&
          x.addOnServiceId === item.addOnServiceId &&
          x.from == item.from &&
          x.to == item.to
      );

      if (index != -1) {
        this.model.selectedServices.splice(index, 1);
        this.$emit("servicesListChanged");
      }

      if (
        item.isBookingFee &&
        !this.model.selectedServices.some((x) => x.isBookingFee)
      ) {
        this.bookingFeeManuallyRemoved = true;
      }
    }
  }

  differenceInDays(date1: Date, date2: Date) {
    const d1 = DateTime.fromJSDate(date1).set({ hour: 0 });
    const d2 = DateTime.fromJSDate(date2).set({ hour: 0 });
    const diff = d2.diff(d1, ["days"]).days;
    return diff;
  }

  // edit addOnService
  editFormOpen = false;
  editFormValid = false;
  editModel: AddOnServiceModel | null = null;
  originalItem: AddOnServiceModel | undefined;
  netPriceForAccUnit: number | undefined;

  openEditForm(item: AddOnServiceModel) {
    if (item.isOTASpecific == false) {
      this.editModel = _.cloneDeep(item);
      this.originalItem = this.model?.availableServices.find(x => x.addOnServiceId === item.addOnServiceId);
      this.editFormOpen = true;
      this.anyFormOpen = true;
      this.netPriceForAccUnit = this.accUnitNetPrice();
      }
  }

  @Watch("addFormOpen", { deep: true })
  addFormModelChanged() {
    if (this.addItemsArray) {
      this.addItemsArray.forEach((item) => this.setGrossPrice(item));
    }
  }

  applyEdit(forceFalseIsEdited = false) {
    if (this.editModel) {
      const service = this.model?.selectedServices.find(
        (x) =>
          x.idx == this.editModel?.idx &&
          x.from == this.editModel.from &&
          x.to == this.editModel.to
      );

      if (service) {
        service.netUnitPrice = this.editModel.netUnitPrice;
        service.discountPercent = this.editModel.discountPercent;
        if (service.decimalQuantity !== this.editModel.decimalQuantity) {
          if (!forceFalseIsEdited) {
            service.isEditedManually = true;
          }
          service.decimalQuantity = this.editModel.decimalQuantity;
        } else {
          service.decimalQuantity = this.editModel.decimalQuantity;
        }
        service.grossPrice = this.editModel.grossPrice;
        service.serviceDateFrom = this.editModel.serviceDateFrom;
        service.serviceDateTo = this.editModel.serviceDateTo;
      }
    }
    this.$emit("servicesListChanged");
    this.editModel = null;
    this.editFormOpen = false;
    this.anyFormOpen = false;
  }

  get rules() {
    return {
      required: (value: any) =>
        !!value || value === 0 || this.$t("Validation.Required"),
      noNegativeNumbers: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 0 ||
        this.$t("Validation.MustBePositive"),
      positiveDiscount: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 0 ||
        this.$t("AOS.Discount"),
      maxDecimals: (value: any) =>
        !(this.countDecimals(value) > 2) ||
        this.$t("Validation.CanOnlyHaveTwoDecimals"),
      requiredDateRange: (value: string[]) =>
        value.length === 2 || this.$t("Validation.RequiredDateRange"),
    };
  }

  countDecimals(num: number) {
    return num.toString().split(".")[1]?.length || 0;
  }

  getRowClass() {
    return "addOnService";
  }

  get addOnServiceQuantityFactors() {
    const stringToday = new Date().toISOString().substring(0, 10);

    return {
      numberOfDays:
        this.model?.arrivalDate && this.model?.departureDate
          ? this.differenceInDays(
              new Date(this.model.arrivalDate),
              new Date(this.model.departureDate)
            )
          : 0,
      numberOfAdults: this.model?.numberOfAdults ?? 0,
      numberOfNonTaxableAdults: this.model?.guests.filter(
        (x) =>
          x.city === this.model?.city &&
          (!x.dateOfBirth ||
            Math.floor(
              differenceInYears(
                new Date(x.dateOfBirth as string),
                new Date(stringToday)
              )
            ) >= 18)
      ).length,
      numberOfChildren: this.model?.numberOfChildren ?? 0,
      numberOfTaxableChildren:
        this.model?.childrenAges.filter((x) => x > 11 && x < 18).length ?? 0,
      unitStayDates: [
        this.model?.arrivalDate.substring(0, 10),
        this.model?.departureDate.substring(0, 10),
      ],
    };
  }

  reAddCityTax = true;

  // this functions readds all services when factors change
  @Watch("addOnServiceQuantityFactors", { deep: true })
  addOnServiceQuantityFactorsChanged(fresh: any, old: any) {
    if (this.model && !_.isEqual(fresh, old)) {
      const unit = this.model;

      if (!unit.selectedServices.some((x) => x.isCityTax)) {
        this.reAddCityTax = false;
      }

      // select cityTax categories which have a tax edited to add later
      const calculationMethodIds = unit.selectedServices
        .filter(
          (x) =>
            !this.calculateWithEVisitorDates &&
            x.isCityTax &&
            x.isEditedManually
        )
        .map((x) => x.calculationMethodId);
      const manuallyEditedServices = unit.selectedServices.filter(
        (x) =>
          x.isCityTax && calculationMethodIds.includes(x.calculationMethodId)
      );

      // select non city taxes to recalculate
      unit.selectedServices = unit.selectedServices.filter((x) => !(x.isCityTax));

      unit.selectedServices.forEach((service) => { 
        const matchingAvailableService = this.model?.availableServices.find(x => x.addOnServiceId === service.addOnServiceId)  ||
        this.model?.selectedServices.find((x) => x.addOnServiceId === service.addOnServiceId);

      if (matchingAvailableService?.isRelative) {
          service.grossUnitPrice = (matchingAvailableService.grossUnitPrice / 100) * (this.accUnitNetPrice() ?? 0);
        }
      });

      //automatically adjust start/end date on services that had the full length
      //of stay period for their period - if the number of days has changed
      if (fresh.numberOfDays !== old.numberOfDays) {
        unit.selectedServices.forEach((service) => {
          if (this.needsRange(service) && !service.pricesAreSeasonal) {
            //basically check if service had the same from-to
            //dates as the "old" from-to dates were on the unit
            //if so, automatically adjust service dates from-to
            //to new unit dates from-to so new calculation method
            //which works on AOS from-to behaves as expected on unit stay change
            if (
              fresh.unitStayDates.length == 2 &&
              old.unitStayDates.length == 2 &&
              service.serviceDateFrom == old.unitStayDates[0].substr(0, 10) &&
              service.serviceDateTo == old.unitStayDates[1].substr(0, 10)
            ) {
              service.serviceDateFrom = fresh.unitStayDates[0].substr(0, 10);
              service.serviceDateTo = fresh.unitStayDates[1].substr(0, 10);
            }
          }
        });
      }

      unit.selectedServices.forEach((service) => {
        if (
          (service.pricesAreSeasonal &&
            (service.calculationMethodId ==
              PriceCalculationMethodsEnum.PerPersonPerNight ||
              service.calculationMethodId ==
                PriceCalculationMethodsEnum.PerChildPerNight ||
              service.calculationMethodId ==
                PriceCalculationMethodsEnum.PerAdultPerNight) &&
            ((old.numberOfAdults == 0 && fresh.numberOfAdults == 1) ||
              (old.numberOfAdults == 1 && fresh.numberOfAdults == 0) ||
              (old.numberOfChildren == 0 && fresh.numberOfChildren == 1) ||
              (old.numberOfChildren == 1 && fresh.numberOfChildren == 0))) ||
          (service.pricesAreSeasonal &&
            old.numberOfDays !== fresh.numberOfDays &&
            this.needsRange(service))
        ) {
          this.addItem(service, true);
        } else if (this.showAOSPeriodColumn) {
          this.seasonalPricesQuantityForAOSRange(service);
        } else {
          calculateAddOnServiceQuantity(
            service,
            unit,
            this.calculateWithEVisitorDates ?? false
          );
        }
        this.setGrossPrice(service);
      });

      // add modified cityTaxes
      unit.selectedServices.push(...manuallyEditedServices);

      if (calculationMethodIds.length > 0) {
        unit.selectedServices = this.removeZeroQuantityCityTax(
          unit.selectedServices
        );
      }

      const services: AddOnServiceModel[] = [];
      const availableTaxes = _.cloneDeep(
        unit.availableServices.filter((x) => x.isCityTax && this.reAddCityTax)
      );
     
      availableTaxes.forEach((service) => { 
        const matchingAvailableService = this.model?.availableServices.find(x => x.addOnServiceId === service.addOnServiceId)  ||
        this.model?.selectedServices.find((x) => x.addOnServiceId === service.addOnServiceId);

        if (matchingAvailableService?.isRelative) {
            service.grossUnitPrice = (matchingAvailableService.grossUnitPrice / 100) * (this.accUnitNetPrice() ?? 0);
          }
      });

      // selecting from available taxes if factors dictate
      if (
        !calculationMethodIds.includes(
          PriceCalculationMethodsEnum.PerAdultPerNight
        )
      ) {
        if (
          this.addOnServiceQuantityFactors.numberOfAdults > 0 ||
          (this.calculateWithEVisitorDates &&
            (unit.guests.some(
              (x) => getAge(x.dateOfBirth ?? new Date()) >= 18
            ) ||
              unit.guests.some((x) => x.dateOfBirth === undefined)))
        ) {
          services.push(
            ...availableTaxes.filter(
              (x) =>
                x.calculationMethodId ==
                PriceCalculationMethodsEnum.PerAdultPerNight
            )
          );
        }
      }
      if (
        !calculationMethodIds.includes(
          PriceCalculationMethodsEnum.PerChildPerNight
        )
      ) {
        if (
          this.addOnServiceQuantityFactors.numberOfTaxableChildren > 0 ||
          (this.calculateWithEVisitorDates &&
            unit.guests.some(
              (x) =>
                getAge(x.dateOfBirth ?? new Date()) > 11 &&
                getAge(x.dateOfBirth ?? new Date()) < 18
            ))
        ) {
          services.push(
            ...availableTaxes.filter(
              (x) =>
                x.calculationMethodId ==
                PriceCalculationMethodsEnum.PerChildPerNight
            )
          );
        }
      }

      // no services exist add those that are added automatically
      if (calculationMethodIds.length == 0 && services.length === 0) {
        const s = _.cloneDeep(
          this.model.availableServices.filter(
            (x) => x.isCityTax && x.isAddedAutomatically && this.reAddCityTax
          )
        );
        services.push(...s);
      }

      // when using this function it calculates for all the factors including date dependent city tax price
      this.add(services);
    }
  }

  // booking fees
  bookingFeeManuallyRemoved = false;
  get bookingFeesFactors() {
    return {
      accommodationPrice: round(
        (this.model?.dayPrices.reduce((sum, x) => sum + x.price, 0) ?? 0) *
          (1 - round((this.model?.discountPercent ?? 0) / 100), 8),
        2
      ),
      servicesPrice:
        this.model?.selectedServices
          .filter(
            (x) => !x.isCityTax && !x.isBookingFee && x.isAddedAutomatically
          )
          .reduce((sum, x) => sum + x.grossPrice, 0) ?? 0,
      bookingFeeManuallyRemoved: this.bookingFeeManuallyRemoved,
    } as BookingFeesFactors;
  }

  @Watch("bookingFeesFactors")
  bookingFeesFactorsWatch(fresh: BookingFeesFactors, old: BookingFeesFactors) {
    // TODO: logic for scenario where booking fees are not all merged into a single item
    // see user story #8198

    const accomodationBookingFee =
      this.model?.ratePlan?.accomodationBookingFee ?? null;
    const addOnServicesBookingFee =
      this.model?.ratePlan?.addOnServicesBookingFee ?? null;

    if (
      accomodationBookingFee === null &&
      addOnServicesBookingFee === null &&
      this.model &&
      this.model.selectedServices.some((x) => x.isBookingFee)
    ) {
      // remove existing booking fee
      this.model.selectedServices = this.model.selectedServices.filter(
        (x) => !x.isBookingFee
      );
    }

    if (
      !this.bookingFeeManuallyRemoved &&
      this.model &&
      !_.isEqual(fresh, old) &&
      (accomodationBookingFee !== null || addOnServicesBookingFee !== null) &&
      this.model.availableServices.some((x) => x.isBookingFee)
    ) {
      // get the booking fee addOnService base
      const bookingFeeServiceBase = this.model.availableServices.filter(
        (x) => x.isBookingFee
      )[0];

      // calculate values
      const accomodationBookingFeeFactor = round(
        (this.model.ratePlan?.accomodationBookingFee ?? 0) / 100,
        8
      );
      const addOnServiceBookingFeeFactor = round(
        (this.model.ratePlan?.addOnServicesBookingFee ?? 0) / 100,
        8
      );
      const bookingFeeTaxRateFactor =
        1 +
        round(
          (this.taxRates?.find((x) => x.id == bookingFeeServiceBase.taxRateId)
            ?.rate ?? 0) / 100,
          8
        );
      const bookingFeePriceGross =
        round(
          this.bookingFeesFactors.accommodationPrice *
            accomodationBookingFeeFactor,
          2
        ) +
        round(
          this.bookingFeesFactors.servicesPrice * addOnServiceBookingFeeFactor,
          2
        );
      const bookingFeePriceNet = round(
        bookingFeePriceGross / bookingFeeTaxRateFactor,
        2
      );

      // add new booking fee
      if (bookingFeePriceGross !== 0) {
        this.model.selectedServices.push({
          ...bookingFeeServiceBase,
          idx: this.model.selectedServices.length,
          id: 0,
          netUnitPrice: bookingFeePriceNet,
          grossPrice: bookingFeePriceGross,
          quantity: 1,
          decimalQuantity: 1,
        } as AddOnServiceModel);
      }
    }
  }
}
